const bulkUpload = (() => {

    const init = () => {
        const form = document.getElementById('formularz-bulk');
        if (!form) return;

        const zone      = document.getElementById('bulk-upload-zone');
        const preview   = document.getElementById('bulk-upload-preview');
        const input     = document.getElementById('bulk_file');
        const errorEl   = document.getElementById('bulk-file-error');
        const filenameEl = document.getElementById('bulk-filename');
        const filesizeEl = document.getElementById('bulk-filesize');
        const fillEl    = document.getElementById('bulk-progress-fill');
        const pctEl     = document.getElementById('bulk-progress-pct');
        const removeBtn = document.getElementById('bulk-remove');

        if (!zone || !input || !preview || !filenameEl || !filesizeEl || !fillEl || !pctEl || !removeBtn || !errorEl) return;

        const maxBytes = parseInt(input.dataset.maxBytes, 10) || (10 * 1024 * 1024);
        const allowed  = (input.dataset.allowed || 'xlsx,csv').split(',');

        const showError = (msg) => {
            errorEl.textContent = msg;
            zone.classList.add('is-error');
        };

        const clearError = () => {
            errorEl.textContent = '';
            zone.classList.remove('is-error');
        };

        const setProgress = (pct) => {
            fillEl.style.width = pct + '%';
            pctEl.textContent  = pct + '%';
            const wrap = document.getElementById('bulk-progress-wrap');
            if (wrap) wrap.setAttribute('aria-valuenow', pct);
        };

        const resetUpload = () => {
            input.value = '';
            preview.hidden = true;
            preview.classList.remove('is-uploading');
            removeBtn.hidden = false;
            clearError();
            setProgress(0);
        };

        const showPreview = (file) => {
            filenameEl.textContent = file.name;
            filesizeEl.textContent = (file.size / 1024 / 1024).toFixed(2) + ' MB';
            preview.hidden = false;
            preview.classList.remove('is-uploading');
            removeBtn.hidden = false;
        };

        input.addEventListener('change', function () {
            clearError();
            const file = this.files[0];
            if (!file) return;

            const ext = file.name.split('.').pop().toLowerCase();

            if (!allowed.includes(ext)) {
                showError('Niedozwolony format pliku. Wybierz plik .xlsx lub .csv.');
                this.value = '';
                return;
            }
            if (file.size > maxBytes) {
                const maxMB = Math.round(maxBytes / 1024 / 1024);
                showError('Plik jest za duży. Maksymalny rozmiar: ' + maxMB + ' MB.');
                this.value = '';
                return;
            }

            showPreview(file);
        });

        removeBtn.addEventListener('click', resetUpload);
        form.addEventListener('reset', resetUpload);

        // Drag & drop na zone — dragover+preventDefault wymagane żeby drop zadziałał
        let dragCount = 0;

        zone.addEventListener('dragenter', (e) => {
            e.preventDefault();
            dragCount++;
            zone.classList.add('is-drag-over');
        });
        zone.addEventListener('dragleave', () => {
            dragCount--;
            if (dragCount === 0) zone.classList.remove('is-drag-over');
        });
        zone.addEventListener('dragover', (e) => e.preventDefault());
        zone.addEventListener('drop', (e) => {
            e.preventDefault();
            dragCount = 0;
            zone.classList.remove('is-drag-over');

            const file = e.dataTransfer?.files?.[0];
            if (!file) return;

            // Przypisz plik do inputa i zasymuluj change (uruchomi walidację i preview)
            try {
                const dt = new DataTransfer();
                dt.items.add(file);
                input.files = dt.files;
            } catch (_) {}
            input.dispatchEvent(new Event('change'));
        });

        // Zapobiega otwieraniu pliku w przeglądarce gdy użytkownik pudłuje poza strefę
        document.addEventListener('dragover', (e) => { if (!zone.contains(e.target)) e.preventDefault(); });
        document.addEventListener('drop',     (e) => { if (!zone.contains(e.target)) e.preventDefault(); });

        // Keyboard
        zone.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                input.click();
            }
        });

        // Progress na faktycznym uploadzię (eventy z validation.js)
        form.addEventListener('xhrUploadStart', () => {
            setProgress(0);
            preview.classList.add('is-uploading');
            removeBtn.hidden = true;
        });

        form.addEventListener('xhrUploadProgress', (e) => {
            const pct = Math.round(e.detail.loaded / e.detail.total * 100);
            setProgress(pct);
        });
    };

    return { init };
})();

export { bulkUpload };
